import { render } from "./views/ZoneTransfer.html?vue&type=template&id=a0a5f7f0&external"
import script from "./ZoneTransfer.vue?vue&type=script&lang=js"
export * from "./ZoneTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__